import { IAttachment } from "@/types/attachment";

export class Attachment implements IAttachment {
  public id = 0;
  public company_id = 0;
  public url = "";
  public hash = "";
  public extension = "";
  public mime_type = "";

  public constructor(props?: IAttachment) {
    if (!props) {
      return;
    }

    Object.assign(this, props);
  }
}
